"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBasicOfferHintTranslations = void 0;
var _react = require("react");
var _useTranslations = require("./useTranslations");
const useBasicOfferHintTranslations = ({
  purchases
}) => {
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const addedItemTitle = (0, _react.useMemo)(() => purchases.length === 1 ? formatMessage('itemToYourBasket', {
    0: purchases[0]?.name
  }) : formatMessage('itemsThatMadeYouEligibleForSpecialOffers'), [purchases, formatMessage]);
  const buy = formatMessage('buy');
  const description = formatMessage('discountedProduct');
  const getOffer = formatMessage('getOffer');
  const headerTitle = formatMessage('setOfProducts');
  return {
    addedItemTitle,
    buy,
    description,
    getOffer,
    headerTitle
  };
};
exports.useBasicOfferHintTranslations = useBasicOfferHintTranslations;